import messages from './messages'

/**
 * Interceptador de requisições com erro
 */
export default async (http, router, store) => {
  http.interceptors.response.use(
    response => messages.success(response, store),
    error => messages.error(error, router, store)
  )
}



// WEBPACK FOOTER //
// ./src/http/interceptors.js